import React, { Component } from 'react';
import { Card, CardBody, Row, Col } from "reactstrap";

//Import Charts
import ReactApexChart from 'react-apexcharts';
import "./dashboard.scss";

class SalesByCategoryAnalytics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            series: [],
            options: {
                labels: [],
                plotOptions: {
                    pie: {
                        startAngle: 0,
                        endAngle: 360,
                        expandOnClick: true,
                        offsetX: 0,
                        offsetY: 0,
                        customScale: 1,
                        dataLabels: {
                            offset: 0,
                            minAngleToShowLabel: 10,
                        },
                        donut: {
                            size: '65%',
                            background: 'transparent',
                            labels: {
                                show: true,
                                name: {
                                    show: true,
                                    fontSize: '22px',
                                    fontWeight: 600,
                                    color: '#888EA8',
                                    offsetY: -10,
                                    formatter: function (val) {
                                        return val
                                    }
                                },
                                value: {
                                    show: true,
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    color: undefined,
                                    offsetY: 16,
                                    formatter: function (val) {
                                        return 'S$ ' + (Number(val) > 0 ? Number(val).toFixed(2) : 0)
                                    }
                                },
                                total: {
                                    show: true,
                                    showAlways: true,
                                    label: 'Total',
                                    fontSize: '22px',
                                    fontWeight: 600,
                                    color: '#888EA8',
                                    formatter: function (w) {
                                        return 'S$ ' + (w.globals.seriesTotals.reduce((a, b) => {
                                            return a + b
                                        }, 0) || 0).toFixed(2)
                                    }
                                }
                            }
                        },
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: true,
                    position: 'bottom',
                    horizontalAlign: 'left',
                    itemMargin: {
                        horizontal: 15,
                        vertical: 5
                    },
                    formatter: function (seriesName, opts) {
                        return '<div className="legend-info">' + '<span>' + seriesName + '</span>' + '</div>'
                    }
                },
                colors: ['#4BC0C0', '#FF6384', '#FF9F40', '#FFCD56',],
                noData: {
                    text: 'No Data',
                    align: 'center',
                    verticalAlign: 'middle',
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: undefined,
                        fontSize: '14px',
                        fontFamily: undefined
                    }
                }
            }
        }
    }

    componentDidMount() {
        // if (this.state.series.length < 1 && this?.props?.sales) {
            let categoryData = [];
            let salesData = [];
            this?.props?.sales && Object.keys(this.props.sales).forEach(key => {
                let amount = this.props.sales[key].replace(/,/g, '');
                categoryData.push(key);
                salesData.push(Number(amount || "0"));
            });
            this.setState({
                series: salesData,
                options: {
                    ...this.state.options,
                    labels: categoryData
                }
            })
        // }
    }

    componentDidUpdate() {
        if (this.state.series.length < 1 && this?.props?.sales) {
            let categoryData = [];
            let salesData = [];
            Object.keys(this.props.sales).forEach(key => {
                let amount = this.props.sales[key].replace(/,/g, '');
                categoryData.push(key);
                salesData.push(Number(amount || "0"));
            });
            this.setState({
                series: salesData,
                options: {
                    ...this.state.options,
                    labels: categoryData
                }
            })
        }
    }

    renderGraph(data) {

        return (
            <div id="donut-chart" className="apex-charts">
                <ReactApexChart options={this.state.options} series={this.state.series} type="donut" height="350" name={'Total'} />
            </div>
        )
    }

    render() {
        return (
            <React.Fragment>
                <Card >
                    <CardBody style={{ minHeight: 466 }}>
                        {/* <div className="float-end d-none d-md-inline-block">
                            <i className="ri-more-fill"></i>
                        </div> */}
                        <div className="graph-header mb-4">Sales By Category</div>
                        {
                            // this?.props?.pawnAmount &&
                            this.renderGraph()
                        }
                        {/* <div id="donut-chart" className="apex-charts">
                            <ReactApexChart options={this.state.options} series={this.state.series} type="donut" height="350" />
                        </div> */}
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

export default SalesByCategoryAnalytics;